// extracted by mini-css-extract-plugin
export default {"screen_container":"EditBlogScreen_screen_container__YW7XZ","horizontal_div":"EditBlogScreen_horizontal_div__FTjHc"};